import styled from 'styled-components';
import Attention from '../../../components/svgs/Attention';
import Eye from '../../../components/svgs/Eye';
import Input from '../../../components/dumbs/Input';
import EyeCrossed from '../../../components/svgs/EyeCrossed';
import Check from '../../../components/svgs/Check';
import ArrowRightPassword from '../../../components/svgs/ArrowRightPassword';
import Text from '../../../components/dumbs/Text';

import { PasswordTip } from './types';

export const MainContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km10};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const ExistingAccessNotice = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const InputPassword = styled(Input)`
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const ConfirmPassword = styled(Input)`
  margin-bottom: ${({ theme }) => theme.spacing.km10};
`;

export const EyeSvg = styled(Eye)``;

export const EyeCrossedSvg = styled(EyeCrossed)``;

export const Warning = styled(Attention)`
  align-self: center;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing.km2};
`;

export const CheckMark = styled(Check)`
  align-self: center;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing.km2};
`;

export const ArrowRightPass = styled(ArrowRightPassword)`
  align-self: center;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing.km2};
`;

export const PasswordInfo = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.km14};
`;

export const SubTitle = styled(Text)`
  font-family: ${({ theme }) => theme.font.family.body};
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`;

export const Description = styled(Text)`
  letter-spacing: -0.03em;
`;

export const InfoSectionOne = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`;

export const InfoSectionTwo = styled.div`
  display: flex;
`;

export const PasswordTipsOne = styled(Text)<PasswordTip>`
  font-family: ${({ theme }) => theme.font.family.body};
  width: 94%;
  color: ${({ hasError, theme }) =>
    hasError
      ? theme.color.text.danger.default
      : theme.color.text.neutral.default};
`;

export const PasswordTipsTwo = styled(Text)<PasswordTip>`
  font-family: ${({ theme }) => theme.font.family.body};
  color: ${({ hasError, theme }) =>
    hasError
      ? theme.color.text.danger.default
      : theme.color.text.neutral.default};
`;
